import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px 0px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #ededed;
  border-radius: 4px;
`;

export const Field = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FieldSet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0;
`;
